import styled from '@emotion/styled';
import { Col } from 'react-bootstrap';

const DocumentDeleteCol = styled(Col)({
  width: '3.125rem',
});

export default DocumentDeleteCol;
